import { install } from "./PluginSetup.js";
import AttributeEditors from "./itemEditor/attributeEditors/index.js";
import ReleaseFirmwareToDeviceGroups from "./ReleaseFirmwareToDeviceGroups.js";
import FirmwareReleaseActionDialog from "./firmwareReleaseAction/FirmwareReleaseActionDialog.js";
import FotaItemEditor from "./itemEditor/FotaItemEditor.js";
import FotaItemEditorUtil from "./itemEditor/FotaItemEditorUtil.js";
export default {
  AttributeEditors,
  ReleaseFirmwareToDeviceGroups,
  FirmwareReleaseActionDialog,
  install,
  FotaItemEditor,
  FotaItemEditorUtil
};